'use strict';

import type { UserActivityCategory } from '../../Entities/User/UserActivityCategory';
import { EntityCollection } from '../EntityCollection';

export class UserActivityCategoryCollection extends EntityCollection<UserActivityCategory> {}
